import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import NhanVayApi from "../../../service/nhanVayApi";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";

export const LichSuGiaHanHopDong = ({ nhanvayId }) => {
  const dataInit = {
    List: [],
  };
  const [dataLichSuGiaHan, UpdateDataLichSuGiaHan] = useState(dataInit);
  const DanhSachLichSuGiaHan = () => {
    NhanVayApi.getLichSuGiaHanNhanVay(nhanvayId).then((response) => {
      UpdateDataLichSuGiaHan({
        ...dataLichSuGiaHan,
        List: response.data.List,
      });
    });
  };

  React.useEffect(() => {
    DanhSachLichSuGiaHan();
  }, []);
  //End fix height tab

  const listItem = () => {
    return (
      dataLichSuGiaHan.List != null &&
      dataLichSuGiaHan.List.map((item, index) => {
        return (
          <>
            <tr className="">
              <td scope="row">{index + 1}</td>
              <td className="">{getDate(item.ThoiGian)}</td>
              <td className="">{item.SoLan}</td>
              <td className="text-left">{item.GhiChu}</td>
            </tr>
          </>
        );
      })
    );
  };
  return (
    <>
      <div className="table-from-detailtl3">
        <div className="Left808x200  Table-main-morman table-noboder-new">
          <div className="table-responsive table-new1">
            <table className="table table-bordered table-hover">
              <thead>
                <tr>
                  <th className="w-stt">STT</th>
                  <th className="w-10">Ngày gia hạn</th>
                  <th className="w-stt">Số lần thêm</th>
                  <th className="text-left">Lý do gia hạn</th>
                </tr>
              </thead>
              <tbody>{listItem()}</tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};
